import { PromisePool } from '@supercharge/promise-pool';
import _ from 'lodash';

import { showModal } from '../actions';
import {
  setProgress,
  showConfirmationModal,
} from '../actions/App';

import { APIintegrationCallMethod } from '../api/Integrations';

import { formatNumber } from '.';
import { getStore } from './App';
import { userCan } from './Auth';
import { addFlashMessage } from './FlashMessages';
import { getIntl } from './IntlInstance';

export const getIntegrationsURLPath = () => (userCan('manage_settings') ? '/admin/settings/integrations' : '/integrations');

export const runAction = (action, params) => {
  const intl = getIntl();
  const { dispatch } = getStore();
  const text = action.texts?.info.replace('{files}', intl.formatMessage({
    defaultMessage: '{count} {count, plural, one {file} other {files}}',
  }, { count: params.length }));

  const errorMessages = [];
  if (action.validations && Object.keys(action.validations).length > 0) {
    params.forEach((file) => {
      Object.keys(action.validations).forEach((validationId) => {
        const validation = action.validations[validationId];
        if (validationId === 'size') {
          if (file.size > validation.value) {
            const readableSize = validation.value_readable || `${formatNumber(validation.value / 1024)} MB`;
            errorMessages.push(
              intl.formatMessage({
                defaultMessage: 'There is a {readableSize} per file limit. Please select another file and try again.',
              }, { readableSize }),
            );
          }
        }
      });
    });
  }

  const modalParams = {
    className: `modal-integration-action modal-integration-${action.serviceId} modal-integration-${action.serviceId}-${action.id}`,
    title: action.texts?.title,
    text,
    files: params,
    errorMessage: _.uniq(errorMessages).join(', '),
    processingText: action.texts?.processing || intl.formatMessage({ defaultMessage: 'Wait...' }),
    confirmText: action.texts?.confirm || intl.formatMessage({ defaultMessage: 'OK' }),
    onConfirm: async () => {
      let counter = 0;
      dispatch(setProgress(params.length, counter));
      const { errors } = await PromisePool
        .withConcurrency(1)
        .for(params)
        .process(async (p) => {
          counter += 1;
          dispatch(setProgress(params.length, counter));
          return APIintegrationCallMethod(action.serviceId, action.method, { uuid: p.uuid });
        });

      if (errors.length > 0) {
        addFlashMessage({
          type: 'danger',
          text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
        });
        return Promise.reject();
      }

      const flashText = action.texts.success.replace('{files}', intl.formatMessage({
        defaultMessage: '{count} {count, plural, one {file} other {files}}',
      }, { count: params.length })).replace('{have been}', intl.formatMessage({
        defaultMessage: '{count, plural, one {has been} other {have been}}',
      }, { count: params.length }));
      addFlashMessage({
        type: 'success',
        text: flashText,
      });
      return Promise.resolve();
    },
  };

  if (!action.modal || action.modal === 'confirmation') {
    dispatch(showConfirmationModal(modalParams));
  } else {
    dispatch(showModal(action.modal, modalParams));
  }
};
